export default function SettingItem({ label, content }) {
  return (
    <li className='row py-2'>
      <p className='col-2 min-w-90'>{label}</p>
      <p className='col'>{content}</p>
    </li>
  );
}
